module.exports = __webpack_public_path__ + "img/carbs-img-4.da539fd1.png";